import React from 'react'
import Link from 'gatsby-link'
import TopNav from '../components/TopNav'
import './index.scss'
import Bio from '../components/Bio'
import Hero from '../components/Hero'
import get from 'lodash/get'

class Template extends React.Component {
  render() {
    const { location, children } = this.props
    const title=get(this,'props.data.site.siteMetadata.hero.title')
    const subtitle=get(this,'props.data.site.siteMetadata.hero.subtitle')
  let header
    // if (location.pathname === '/') {
      header = (
        <TopNav>
          
        </TopNav>
        // <h1>
        //   <Link to={'/'} >
        //     @fibasile blog
        //   </Link>
        // </h1>
      )
    let hero
    if (location.pathname === '/') {
      hero = (
        <Hero title={title}
              subtitle={subtitle}></Hero>
      )
    } else if (location.pathname === '/about'){
      hero = (
        <Hero title={'About'} subtitle={'Learn more about me'}></Hero>
      )      
    } else if (location.pathname === '/radar'){
      hero = (
        <Hero title={'On my radar'} subtitle={'Stuff worth bookmarking, in chronological order'}></Hero>

      )
    } else if (location.pathname === '/projects'){
      hero = (
        <Hero title={'Projects'} subtitle={'Check out my work, open source software and projects'}></Hero>
      )
    }
    let sidebar
    if (location.pathname === '/') {
      sidebar = (
          <div className="column is-one-third">
            <Bio />
          </div>
      )
    }

    
    // } else {
    //   header = (
    //     <h3>
    //       <Link to={'/'}>
    //         @fibasile blog
    //       </Link>
    //     </h3>
    //   )
    // }
    return (
      <div>
        {hero}
        {header}
        <section className="section">
        <div className="container">
        <div className="columns">
          <div className="column">
          {children()}
          </div>
          {sidebar}
        </div>
        </div>
        </section>
      </div>
    )
  }
}

Template.propTypes = {
  children: React.PropTypes.func,
  location: React.PropTypes.object,
  route: React.PropTypes.object,
}

export const pageQuery = graphql`
  query LayoutIndexQuery {
    site {
      siteMetadata {
        title
        hero {
          title
          subtitle
        }
      }
    }
  }
`

export default Template



// WEBPACK FOOTER //
// ./src/layouts/index.js